import { useQuery } from 'react-query';
import { getIndividual } from '~/api/individuals';

export const useIndividual = (individualId: string | undefined) => {
  return useQuery(
    ['individual', individualId],
    () => getIndividual(individualId!).then((res) => res.data),
    {
      enabled: !!individualId,
    }
  );
};
